import React from 'react';
const ImageDefaultPropsContext = React.createContext({
    shouldUseHighDPIImage: false,
});
export default ImageDefaultPropsContext;
//# sourceMappingURL=ImageDefaultPropsContext.js.map